import { usePermissions } from '@/composables/usePermissions'
import { useProfileStore } from '@/stores/profile'

/**
 * Middleware pour vérifier si l'utilisateur appartient à un ou plusieurs groupes requis
 * Utilisation: definePageMeta({ middleware: ['auth', 'check-groups'], groupsRequired: ['RH', 'Administration'] })
 */
export default defineNuxtRouteMiddleware(async (to) => {
    // Attendre que le profil soit chargé
    const profileStore = useProfileStore()

    // Si le profil n'est pas encore chargé, attendre
    if (!profileStore.profile) {
        try {
            await profileStore.fetchProfile()
        } catch (error) {
            console.error('Erreur lors du chargement du profil:', error)
            return navigateTo('/auth/login')
        }
    }

    const { isSuperAdmin, hasAnyGroup } = usePermissions()

    // Récupérer les groupes requis depuis la meta de la page
    const groupsRequired = (to.meta.groupsRequired as string[]) || []

    // Si aucun groupe requis, laisser passer
    if (groupsRequired.length === 0) {
        return
    }

    // SuperAdmin a toujours accès
    if (isSuperAdmin.value) {
        return
    }

    // Vérifier si l'utilisateur a au moins un des groupes requis
    if (!hasAnyGroup(groupsRequired as any[])) {
        const { homePath } = useHomePath()
        return navigateTo(homePath())
    }
})
